import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { CompanyLogoQuery } from "../../../graphql/deliveryService/queries/companyLogo";

interface useCompanyLogoQueryProps {
  skip: boolean;
  dataAction: (url: string) => void;
  errorAction?: () => void;
}

const useCompanyLogoQuery = (props: useCompanyLogoQueryProps) => {
  const { t } = useTranslation();
  const { skip, dataAction, errorAction } = props;

  const query = useQuery(CompanyLogoQuery, { skip });

  const { data, error } = query;

  const companyLogoUrl = data?.logoUrl;

  useEffect(() => {
    if (!error) return;

    errorAction && errorAction();
    //handleError(t("companyLogoError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !companyLogoUrl) return;

    dataAction(companyLogoUrl);
  }, [data]);

  return query;
};

export default useCompanyLogoQuery;
